import React, { Component } from "react";
import PropTypes from "prop-types";
import { ExportCSVButton } from "react-bootstrap-table";
import ExportReportModal from "./ExportReportModal";

class ExportReportButton extends Component {
  state = {
    modalIsOpen: false,
  };

  handleClick = () => {
    this.setState({ modalIsOpen: true });
  };

  handleRequestClose = () => {
    this.setState({ modalIsOpen: false });
  };

  render() {
    const btnText = this.props.notext ? "" : "Export";

    return (
      <div>
        <ExportCSVButton btnText={btnText} onClick={this.handleClick} />
        <ExportReportModal
          params={this.props.params}
          requestReport={this.props.requestReport}
          modalIsOpen={this.state.modalIsOpen}
          onRequestClose={this.handleRequestClose}
          disableDateRangePicker={this.props.disableDateRangePicker}
          initialDates={this.props.initialDates}
          disableSelectedBeforeCurrentDate={
            this.props.disableSelectedBeforeCurrentDate
          }
          fromAccountDetails={this.props.fromAccountDetails}
        />
      </div>
    );
  }
}

ExportReportButton.defaultProps = {
  params: {},
  requestReport: () => {},
  notext: false,
  disableDateRangePicker: false,
  fromAccountDetails: false,
};

ExportReportButton.propTypes = {
  params: PropTypes.object.isRequired,
  requestReport: PropTypes.func.isRequired,
  notext: PropTypes.bool,
  disableDateRangePicker: PropTypes.bool,
  disableSelectedBeforeCurrentDate: PropTypes.number,
  initialDates: ExportReportModal.propTypes.initialDates,
  fromAccountDetails: ExportReportModal.propTypes.fromAccountDetails,
};

export default ExportReportButton;
